import { useEffect } from 'react';

import type { ByfunnFrapiArticle } from '../../types/frapi-types.js';

import { console } from '../../../core/system/console/console.server.js';

const ALLOWED_ORIGINS = ['https://www.ruter.no', 'https://ruter.no'];

export const useRuterAdsMessaging = ({
  article,
  disable = false,
}: {
  article: ByfunnFrapiArticle;
  disable: boolean;
}): void => {
  useEffect(() => {
    if (disable) {
      return () => null;
    }

    const handleMessage = (event: MessageEvent): void => {
      if (new URLSearchParams(window.location.search).has('debug_ruter')) {
        console.log('[Ruter debugging]', event);
      }

      if (!ALLOWED_ORIGINS.includes(event.origin)) {
        return;
      }

      const message = event.data;

      if (
        message?.action !== 'adCallbackRequest' ||
        message?.payload?.context !== 'restaurantAddress'
      ) {
        return;
      }

      try {
        event.source?.postMessage(
          {
            action: 'restaurantAddressCallback',
            payload: {
              name: article.restaurantTitle,
              address: article.restaurantAddress,
            },
          },
          { targetOrigin: event.origin },
        );
      } catch (error) {
        console.error(`Error posting message to ${event.origin}:`, error);
      }
    };

    window.addEventListener('message', handleMessage);

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [article.restaurantAddress, article.restaurantTitle]);
};
